import { render } from "./ArticleFilter.vue?vue&type=template&id=ff46421c"
import script from "./ArticleFilter.vue?vue&type=script&lang=js"
export * from "./ArticleFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__